import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ADMIN_USER_FEATURE_KEY,
  State,
  AdminPartialState,
  adminUserAdapter
} from './admin-user.reducer';

export const getState = createFeatureSelector<AdminPartialState, State>(
  ADMIN_USER_FEATURE_KEY
);

const { selectAll, selectEntities } = adminUserAdapter.getSelectors();

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getError = createSelector(getState, (state: State) => state.error);

export const getAdminUsers = createSelector(getState, (state: State) =>
  selectAll(state)
);

export const getAdminUsersEntities = createSelector(getState, (state: State) =>
  selectEntities(state)
);

export const getResetPassModal = createSelector(
  getState,
  (state: State) => state.resetPassModal
);

export const getAddAdminUser = createSelector(
  getState,
  (state: State) => state.addAdminUser
);

export const selectAvailableGroups = createSelector(
  getState,
  getAdminUsers,
  (state, users) =>
    [...new Set(users?.map?.(user => user.groups).flat() || [])].filter(Boolean)
);